import type { RequestStatus } from "../types";
import { useT } from "../i18n";

/**
 * The status word, in the reader's language.
 *
 * Keys rather than English literals, because this badge appears on the overview,
 * the request list, the detail modal and the search results — four screens that
 * would otherwise each need their own copy of the same six words.
 */
const KEYS: Record<RequestStatus, string> = {
  pending: "status.pending",
  approved: "status.approved",
  in_progress: "status.in_progress",
  completed: "status.completed",
  rejected: "status.rejected",
  canceled: "status.canceled",
};

export default function StatusBadge({ status }: { status: RequestStatus }) {
  const t = useT();
  return <span className={`status-badge status-${status}`}>{t(KEYS[status])}</span>;
}
